import React, { MouseEvent, useEffect, useState } from "react";
import audience from "../../../icons/audience.png";
import black from "../../../black.jpg";
import TextUtil from "../../../utils/textUtil";
import "./StoryCard.scss";
import { Add, Done, Favorite, Visibility } from "@material-ui/icons";
import Cookies from "js-cookie";
import config from "../../../config/apiConfig";
import read from '../../../icons/read.png';
import ReactGA from 'react-ga';

type Props = {
    index?: number;
    image: string | null;
    score: number;
    id: string;
    title: string;
    isLiked: boolean;
    isRead: boolean;
    isAdded: boolean;
    fb_reactions: number;
    fb_comments: number;
    fb_shares: number;
    onScrapChange?: () => any;
};

const StoryCard: React.FC<Props> = (props) => {
    const [isLiked, setIsLiked] = useState(false);
    const [added, setAdded] = useState(false);

    useEffect(() => {
        setIsLiked(props.isLiked);
        setAdded(props.isAdded);
    }, []);

    function handleNoImage(e: any) {
        e.target.src = black;
    }

    function handleLike(
        e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) {
        e.stopPropagation();
        setIsLiked((s) => !s);
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        formData.append("cid", props.id);
        formData.append("ctype", "article");
        const requestParams = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/v1/put/interactions/like", requestParams);
    }

    async function handleAdd(
        e: React.MouseEvent<HTMLButtonElement, globalThis.MouseEvent>
    ) {
        e.stopPropagation();
        const isAdded = added;
        setAdded((s) => !s);
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        const requestParams = {
            method: "POST",
            body: formData,
        };
        if (!added) {
            ReactGA.event({
                category: 'Scrapbook',
                action: 'Add to scrapbook',
                label: props.id,
            });
            await fetch(
                config.BASE_URL + "/v1/put/scrapbook/add?story_id=" + props.id,
                requestParams
            );
        } else {
            ReactGA.event({
                category: 'Scrapbook',
                action: 'Delete from scrapbook',
                label: props.id,
            });
            await fetch(
                config.BASE_URL +
                "/v1/put/scrapbook/delete?story_id=" +
                props.id,
                requestParams
            );
        }
        if (!!props.onScrapChange)
            props.onScrapChange();
    }

    return (
        <div className="story__box story__card">
            <div className="story__right">
                {/* <Link className="story__add" to={`/story/${story.id}`} style={{borderLeft: "5px solid #c3e36a", borderRight:"0", borderTop:"0", borderBottom:"0", borderRadius: "0", transition: 'all 0.5s ease'}}>Read more</Link> */}
            </div>
            <div className="story__left">
                {props.image ? (
                    <img
                        src={props.image}
                        style={{
                            objectFit: "cover",
                        }}
                        onError={handleNoImage}
                        className={
                            "story__banner pink-filter" +
                            (props.index !== undefined
                                ? ` filter-${props.index % 8}`
                                : "")
                        }
                    />
                ) : (
                    <img
                        src={black}
                        style={{
                            objectFit: "cover",
                        }}
                        className={
                            "story__banner pink-filter" +
                            (props.index !== undefined
                                ? ` filter-${props.index % 8}`
                                : "")
                        }
                    />
                )}

                {/* {props.isRead && <div className="grey__back">
                    <img src={read} alt="" width={24} />
                </div>} */}
                <div className={"story__actions"}>
                    <button
                        style={{
                            backgroundColor: isLiked ? "#ffffff" : undefined,
                        }}
                        onClick={handleLike}
                    >
                        <Favorite
                            style={{ fill: isLiked ? config.primary_color : "#cbcbcb" }}
                        />
                    </button>
                    <button
                        style={{
                            backgroundColor: added ? "#ffffff" : undefined,
                        }}
                        onClick={handleAdd}
                    >
                        {!added ? (
                            <Add style={{ fill: "#cbcbcb" }} />
                        ) : (
                            <Done style={{ fill: "#0ba3d0" }} />
                        )}
                    </button>
                </div>
                <div className="gradient__back">
                    <h5 className="small__header">
                        {props.title.length > 80
                            ? props.title.substr(0, 80) + "....."
                            : props.title}
                    </h5>
                    <div className="shadow__text">
                        <Visibility
                            style={{
                                fontSize: "12px",
                            }}
                        />
                        <p
                            style={{
                                margin: "0 0 0 5px",
                                textShadow: "0 0px 10px black",
                            }}
                        >
                            100 views
                        </p>
                        &nbsp;&bull;&nbsp;
                        <p
                            style={{
                                margin: "0 0 0 5px",
                                textShadow: "0 0px 10px black",
                            }}
                        >
                            Score: {(props.score * 100).toString().substr(0, 2)}
                            %
                        </p>
                    </div>
                </div>
                <div className="info">
                    <div className="circular_avatar">
                        <img
                            src={audience}
                            style={{
                                filter: "brightness(0) invert(0)",
                            }}
                            width="18px"
                        />
                    </div>
                    <p
                        style={{
                            margin: "0 0 0 5px",
                        }}
                    >
                        {TextUtil.getNumbersFormatted(props.fb_reactions)}{" "}
                        Reactions,{" "}
                        {TextUtil.getNumbersFormatted(props.fb_comments)}{" "}
                        Comments,{" "}
                        {TextUtil.getNumbersFormatted(props.fb_shares)} Shares
                    </p>
                </div>
            </div>
        </div>
    );
};

export default StoryCard;
